var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.331,
    height: 18.374,
    viewBox: "0 0 16.331 18.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.572,355.564a1.641,1.641,0,0,0-2.232-.587l-4.088,2.373v-4.723a1.621,1.621,0,0,0-3.243,0v4.723l-4.088-2.373a1.632,1.632,0,1,0-1.645,2.82l4.112,2.4-4.112,2.4a1.632,1.632,0,1,0,1.645,2.82l4.088-2.373v4.723a1.621,1.621,0,0,0,3.243,0v-4.723l4.088,2.373a1.632,1.632,0,1,0,1.645-2.82l-4.112-2.4,4.112-2.4A1.626,1.626,0,0,0,27.572,355.564Z",
    transform: "translate(-11.47 -351.006)",
    fill: "#122d5b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStarIcon);
export default __webpack_public_path__ + "static/media/blueStarIcon.b5fdbff04cace1b7c226f6a875f52a25.svg";
export { ForwardRef as ReactComponent };